export default __webpack_public_path__ + "static/media/list-view-icon.25ea8a98.svg";